import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomTable from "../../components/CustomTable/CustomTable";
import AddIesaAdvantage from "./AddIesaAdvantage";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { log } from "console";
import { toast } from "react-toastify";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";

const IesaAdvantage = () => {
  const [showAddIesaAdvantage, setShowAddIesaAdvantage] = useState(false);
  const [iesaAdvantages, setIesaAdvantages] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [iesaAdvantageToDelete, setIesaAdvantageToDelete] = useState<
    string | null
  >(null);
  const [iesaAdvantageToEdit, setIesaAdvantageToEdit] = useState<any | null>(
    null
  );
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  useEffect(() => {
    getEvents();
  }, [currentPage]);

  const getEvents = () => {
    WebService.getAPI({
      action: `iesa-advantages/get-iesa-advantages?page=${currentPage}&limit=${itemsPerPage}`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};

        console.log("l;og", perm);
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });

        for (let i in res?.data?.data) {
          res.data.data[i].action = (
            <div>
              {perm.canEdit && (
                <PencilFill
                  className="me-3 cursor-pointer"
                  onClick={() => {
                    setShowAddIesaAdvantage(true);
                    setIesaAdvantageToEdit(res.data.data[i]);
                  }}
                />
              )}

              {perm.canDelete && (
                <TrashFill
                  color="#DC143C"
                  className="cursor-pointer"
                  onClick={() => handleDeleteEvent(res.data.data[i]._id)}
                />
              )}
            </div>
          );
        }
        setIesaAdvantages(res?.data?.data);
        setTotalCount(res?.data?.pagination?.total);
      })
      .catch((err: any) => {});
  };

  const handleReorder = (newRows: any) => {
    setIesaAdvantages(newRows);

    const reorderedPayload = newRows.map((item: any, index: number) => ({
      _id: item._id,
      order_by: index + 1,
    }));

    WebService.postAPI({
      action: "iesa-advantages/update-order",
      body: reorderedPayload,
    })
      .then(() => {})
      .catch(() => {
        toast.error("Failed to update order");
      });
  };
  const handleDeleteEvent = (iesaAdvantageId: string) => {
    setIesaAdvantageToDelete(iesaAdvantageId);
    setShowDeleteModal(true);
  };

  return (
    <>
      <AddIesaAdvantage
        show={showAddIesaAdvantage}
        handleClose={() => {
          setShowAddIesaAdvantage(false);
          getEvents();
          setIesaAdvantageToEdit(null);
        }}
        data={iesaAdvantageToEdit}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (iesaAdvantageToDelete) {
            WebService.deleteAPI({
              action: `iesa-advantages/delete-iesa-advantage/${iesaAdvantageToDelete}`,
            }).then(() => {
              setShowDeleteModal(false);
              getEvents();
            });
          }
        }}
      />
      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">IESA Advantage</div>
                {pagePermission.canAdd && (
            <CustomButton
              isLoading={false}
              label="Add IESA Advantage"
              onClick={() => {
                setIesaAdvantageToEdit(null);
                setShowAddIesaAdvantage(true);
              }}
              style={{ width: 180 }}
            />  )}
          </div>

          <CustomTableSortable
            columns={[
              { id: "title", label: "Title", minWidth: 170 },
              { id: "action", label: "Action", minWidth: 100, align: "center" },
            ]}
            rows={iesaAdvantages}
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={itemsPerPage}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
            draggable // 👈 enable drag
            onRowsReorder={handleReorder} // 👈 handle dropping
          />
        </Card>
      </div>
    </>
  );
};

export default IesaAdvantage;
